<template lang='pug'>
#nav
	img#logo(src='@/assets/logo_rautt.svg' @click='changeNav("header")')
	#burger(@click='openNav')
		.top
		.mid
		.bot
	#burger-content(:class='{ active: nav }' v-click-outside='closeNav')
		.cross(@click='closeNav')
			.switch
			.swatch
		.links
			p(@click='changeNav("section1-anchor")') Brot af því besta
			p(@click='changeNav("section2-anchor")') Um sápuboltann
			p(@click='changeNav("schedule-anchor")') Dagskrá
			p(@click='changeNav("section3-anchor")') Verðlisti
			p(@click='changeNav("section4-anchor")') Miðakaup
</template>

<script>
import ClickOutside from 'vue-click-outside';
export default {
	name: 'Nav',
	directives: {
		ClickOutside
	},
	data: function () {
		return {
			nav: false,
			blockClose: false
		};
	},
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		},
		openLink: function (target) {
			window.open(target, '_blank').focus();
		},
		openNav: function () {
			this.blockClose = true;
			this.nav = true;
			setTimeout(() => {
				this.blockClose = false;
			}, 300);
		},
		closeNav: function () {
			if (!this.blockClose) {
				this.nav = false;
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#nav {
	background-color: white;
	height: 78px;
	width: 100vw;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 200;
	#burger-content {
		position: fixed;
		top: 0px;
		right: 0px;
		width: 400px;
		@media screen and (max-width: 400px) {
			width: 100vw;
		}
		height: 100vh;
		background-color: #f3736b;
		transform: translateX(400px);
		transition: .3s;
		&.active {
			transform: translateX(0px);
		}
		.cross {
			position: absolute;
			right: 30px;
			top: 30px;
			cursor: pointer;
			.switch {
				width: 30px;
				height: 4px;
				background-color: #118acd;
				transform: rotate(45deg);
				transition: .3s;
			}
			.swatch {
				width: 30px;
				height: 4px;
				background-color: #118acd;
				transform: rotate(-45deg);
				transition: .3s;
			}
			&:hover {
				.switch, .swatch {
					background-color: #0d4664;
				}
				.switch {
					transform: rotate(40deg);
				}
				.swatch {
					transform: rotate(-40deg);
				}
			}
		}
		.links {
			position: absolute;
			top: 45px;
			left: 30px;
			p {
				color: #06293b;
				font-weight: bold;
				font-size: 21px;
				transition: .3s;
				&:hover {
					cursor: pointer;
					color: #118acd;
				}
			}
		}
	}
	#logo {
		margin-left: 117px;
		margin-top: 14px;
		@media screen and (max-width: 1050px) {
			margin-left: 71px;
		}
		@media screen and (max-width: 400px) {
			margin-left: 31px;
		}
		cursor: pointer;
		transition: .3s;
		transform: scale(1);
		&:hover {
			transform: scale(.95);
		}
	}
	#burger {
		cursor: pointer;
		position: absolute;
		top: 27px;
		right: 118px;
		@media screen and (max-width: 1050px) {
			right: 71px;
		}
		@media screen and (max-width: 400px) {
			right: 31px;
		}
		.top, .mid {
			margin-bottom: 7px;
			width: 37px;
			height: 1px;
			border: solid 2px #f3736b;
			background-color: #f3736b;
			border-radius: 8px;
			transition: .3s;
		}
		.bot {
			margin-bottom: 10px;
			width: 18px;
			height: 1px;
			transform: translateX(19px);
			border: solid 2px #f3736b;
			background-color: #f3736b;
			border-radius: 8px;
			transition: .3s;
		}
		&:hover {
			.top, .mid, .bot {
				border: solid 2px #118acd;
				background-color: #118acd;
			}
		}
	}
}
</style>
